module.exports = __webpack_public_path__ + "static/img/img32.85b7f77d.png";